import { Component } from '@angular/core';
import {KeyValuePipe, NgForOf} from "@angular/common";

@Component({
  selector: 'app-hero-contact',
  standalone: true,
  imports: [
    KeyValuePipe,
    NgForOf
  ],
  templateUrl: './hero-contact.component.html',
  styleUrl: './hero-contact.component.css'
})
export class HeroContactComponent {

  sucursales = [
    {
      name: "Guayaquil - Quito - Babahoyo",
      numberPhone: "5 50 50 52"
    }
  ]


}
